export default __webpack_public_path__ + "static/media/area-28.44295d3d.jpg";